export const categories = [
  {
    id: '1',
    name: 'AI Writing Tools',
    description: 'Generate blog posts, marketing copy, and content with AI-powered writing assistants.',
    icon: 'ri-quill-pen-line',
    toolCount: 26
  },
  {
    id: '2',
    name: 'AI Image Generators',
    description: 'Create stunning visuals, art, and graphics from text descriptions using AI.',
    icon: 'ri-image-line',
    toolCount: 19
  },
  {
    id: '3',
    name: 'AI Video Tools',
    description: 'Edit, generate, and enhance videos with AI-powered video creation platforms.',
    icon: 'ri-video-line',
    toolCount: 15
  },
  {
    id: '4',
    name: 'AI Website Builders',
    description: 'Build professional websites in minutes with AI-powered design and content generation.',
    icon: 'ri-layout-line',
    toolCount: 9
  },
  {
    id: '5',
    name: 'AI Marketing Tools',
    description: 'Automate marketing campaigns, email outreach, and customer engagement with AI.',
    icon: 'ri-megaphone-line',
    toolCount: 14
  },
  {
    id: '6',
    name: 'AI Productivity Tools',
    description: 'Boost efficiency with AI assistants, automation, and workflow optimization tools.',
    icon: 'ri-rocket-line',
    toolCount: 20
  },
  {
    id: '7',
    name: 'AI Coding Tools',
    description: 'Write code faster with AI pair programmers and intelligent code completion.',
    icon: 'ri-code-line',
    toolCount: 13
  },
  {
    id: '8',
    name: 'AI Design Tools',
    description: 'Create professional designs, logos, and graphics with AI-powered design platforms.',
    icon: 'ri-palette-line',
    toolCount: 10
  },
  {
    id: '9',
    name: 'AI Automation Tools',
    description: 'Automate workflows, build AI agents, and connect apps without code using intelligent automation platforms.',
    icon: 'ri-share-network-line',
    toolCount: 18
  }
];
